/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { AuthApi } from "@/apis/clients";
import { wrap } from "@/apis/wrap";

const authApi = {
  get: wrap(AuthApi, AuthApi.prototype.authGet),
  login: wrap(AuthApi, AuthApi.prototype.postLogin),
  logout: wrap(AuthApi, AuthApi.prototype.postLogout),
  forgotPassword: wrap(AuthApi, AuthApi.prototype.postForgotPassword),
  resetPassword: wrap(AuthApi, AuthApi.prototype.postResetPassword),
};

export default authApi;
